export const downloadFile = async (fileUrl: string, filename?: string) => {
  const a = document.createElement("a");
  a.href = fileUrl;
  a.download = filename ?? "";
  document.body.appendChild(a);
  a.click();
  a.remove();
};
